











































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import { electivePostponementModule } from "@/store/modules/ElectivePostponementStore";
import { appModule } from "@/store/modules/app";
import Service from "@/services/ElectivePostponementService";
import ElectivePostponementForm from "@/components/ibs/ElectivePostponementForm.vue";

@Component({
  components: { ElectivePostponementForm }
})
export default class ElectivePostponementPage extends Vue {
  activeTab = 0;
  showForm = false;
  editingId: number | null = null;

  // Dashboard state
  dashboardTanggal = localISODate();
  dashboardUnit: string | null = null;

  // Report state
  reportTanggal = localISODate();
  reportUnit: string | null = null;

  // Pareto state
  paretoMode: "monthly" | "quarterly" = "monthly";
  paretoBulan = new Date().getMonth() + 1;
  paretoKuartal = Math.ceil((new Date().getMonth() + 1) / 3);
  paretoTahun = new Date().getFullYear();
  paretoUnit: string | null = null;

  get store() {
    return electivePostponementModule;
  }

  get filters() {
    return electivePostponementModule.filters;
  }

  get bulanOptions() {
    return [
      { text: "Januari", value: 1 }, { text: "Februari", value: 2 },
      { text: "Maret", value: 3 }, { text: "April", value: 4 },
      { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
      { text: "Juli", value: 7 }, { text: "Agustus", value: 8 },
      { text: "September", value: 9 }, { text: "Oktober", value: 10 },
      { text: "November", value: 11 }, { text: "Desember", value: 12 }
    ];
  }

  get unitOptions() {
    return [
      { text: "IBS", value: "ibs" },
      { text: "OK Central", value: "ok_central" },
      { text: "OK Elektif", value: "ok_elektif" },
      { text: "Poli Bedah", value: "poli_bedah" }
    ];
  }

  get eksekusiOptions() {
    return [
      { text: "Tidak Tertunda", value: "tidak" },
      { text: "Tertunda", value: "tertunda" },
      { text: "Eksklusi", value: "eks" }
    ];
  }

  get tableHeaders() {
    return [
      { text: "No. Formulir", value: "nomor_formulir", sortable: false },
      { text: "Tanggal", value: "tanggal_operasi" },
      { text: "Unit OK", value: "unit_kamar_operasi" },
      { text: "Pasien", value: "nama_pasien" },
      { text: "No. RM", value: "no_rekam_medis" },
      { text: "Operator", value: "dokter_operator_nama" },
      { text: "T-jadwal", value: "t_jadwal" },
      { text: "T-aktual", value: "t_aktual" },
      { text: "Selisih", value: "selisih_menit" },
      { text: "Status", value: "eksekusi" },
      { text: "Workflow", value: "status" },
      { text: "Aksi", value: "actions", sortable: false, width: 80 }
    ];
  }

  get paretoHeaders() {
    return [
      { text: "Kode", value: "kode" },
      { text: "Nama Penyebab", value: "nama" },
      { text: "Jumlah", value: "count", align: "center" },
      { text: "% Individual", value: "persen", align: "center" },
      { text: "% Kumulatif", value: "cumulative_persen", align: "center" }
    ];
  }

  get vitalFew() {
    return (this.store.paretoData || []).filter((p: any) => p.cumulative_persen <= 80);
  }

  get capaianColor() {
    const d = this.store.dashboard;
    if (!d) return "grey--text";
    return d.capaian_hari_ini.capaian_persen <= d.target_persen
      ? "success--text"
      : "error--text";
  }

  async mounted() {
    await this.store.fetchReasonDefinitions();
    await this.loadEvents();
    await this.loadDashboard();
  }

  async loadEvents() {
    await this.store.fetchEvents(this.filters);
  }

  async loadDashboard() {
    await this.store.fetchDashboard({
      tanggal: this.dashboardTanggal,
      unit_kamar_operasi: this.dashboardUnit || undefined
    });
  }

  async loadAllPeriods() {
    await this.store.fetchAllPeriods({
      tanggal: this.reportTanggal,
      unit_kamar_operasi: this.reportUnit || undefined
    });
  }

  async loadPareto() {
    const params: any = {
      tahun: this.paretoTahun,
      unit_kamar_operasi: this.paretoUnit || undefined
    };
    if (this.paretoMode === "monthly") {
      params.bulan = this.paretoBulan;
    } else {
      params.kuartal = this.paretoKuartal;
    }
    await this.store.fetchPareto(params);
  }

  async generateMonthlyReport() {
    const d = new Date(this.reportTanggal);
    await this.store.generateMonthly({
      bulan: d.getMonth() + 1,
      tahun: d.getFullYear(),
      unit_kamar_operasi: this.reportUnit || undefined
    });
    appModule.sendSuccessNotice("Laporan bulanan berhasil digenerate.");
    await this.loadAllPeriods();
  }

  onPageChange(page: number) {
    this.store.SET_PAGINATION({ ...this.store.pagination, currentPage: page });
    this.loadEvents();
  }

  tambahBaru() {
    this.editingId = null;
    this.showForm = true;
  }

  openDetail(item: any) {
    this.editingId = item.id;
    this.showForm = true;
  }

  openDetailById(id: number) {
    this.editingId = id;
    this.activeTab = 0;
    this.showForm = true;
  }

  openPdf(item: any) {
    const url = Service.getPdfUrl(item.id);
    window.open(url, "_blank");
  }

  onFormSaved() {
    this.showForm = false;
    this.editingId = null;
    this.loadEvents();
    this.loadDashboard();
  }

  // --- Formatters ---

  formatTanggal(v: string) {
    if (!v) return "-";
    return new Date(v).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }

  formatJam(v: string) {
    if (!v) return "-";
    return new Date(v).toLocaleTimeString("id-ID", {
      hour: "2-digit",
      minute: "2-digit"
    });
  }

  eksekusiColor(v: string) {
    if (v === "tertunda") return "red";
    if (v === "tidak") return "green";
    if (v === "eks") return "grey";
    return "blue-grey";
  }

  eksekusiLabel(v: string) {
    if (v === "tertunda") return "Tertunda";
    if (v === "tidak") return "Tepat Waktu";
    if (v === "eks") return "Eksklusi";
    return v || "-";
  }

  statusLabel(v: string) {
    const map: Record<string, string> = {
      draft: "Draft",
      pending_aktual: "Menunggu T-aktual",
      reported: "Dilaporkan",
      verified: "Diverifikasi",
      approved: "Disetujui",
      closed: "Ditutup"
    };
    return map[v] || v;
  }
}
